<template>
  <div style="display: flex; justify-content: center">
    <div>
      <div class="section">
        <div>
          <div class="section_image">
            <!--  -->
            <div
              v-if="imageData[0] != undefined"
              style="position: relative; width: 12rem !important"
            >
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(0)"></div>
              </div>
              <img
                v-if="
                  imageData[0].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                style="position: relative; width: 12rem !important"
                :src="`${imageData[0]}.webp`"
                id="plaquetadedeidentificacaoPreviewEdit"
                @click="clickPreview(imageData[0])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[0]}`"
                id="plaquetadedeidentificacaoPreviewEdit"
                @click="clickPreview(imageData[0])"
                style="position: relative; width: 12rem !important"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="plaquetadeidentificação"
                  @change="previewFiles($event, 0)"
                  multiple
                  hidden
                />
                <label class="palavra" for="plaquetadeidentificação">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>

            <!--  -->

            <div>
              <p class="title">Plaqueta de Identificação</p>
              <div>
                <div class="btn-group" v-if="imageData[0] != undefined">
                  <label
                    class="botao-editar"
                    for="FotoPlaquetadeIdentificacaodomoldePreviewEdit"
                  ></label>
                  <input
                    hidden
                    type="file"
                    accept="image/*"
                    @change="previewFiles($event, 0)"
                    id="FotoPlaquetadeIdentificacaodomoldePreviewEdit"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section_image">
          <div>
            <!--  -->
            <div class="image-preview" v-if="imageData[1] != undefined">
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(1)"></div>
              </div>
              <img
                v-if="
                  imageData[1].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                :src="`${imageData[1]}.webp`"
                id="fotoidcameraquentePreviewEdit"
                @click="clickPreview(imageData[1])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[1]}`"
                id="fotoidcameraquentePreviewEdit"
                @click="clickPreview(imageData[1])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="idcameraquente"
                  @change="previewFiles($event, 1)"
                  multiple
                  hidden
                />
                <label class="palavra" for="idcameraquente">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>

            <!--  -->

            <div>
              <p class="title">ID da Câmara Quente</p>
              <div class="icons">
                <div class="btn-group" v-if="imageData[1] != undefined">
                  <label class="botao-editar" for="IDdaCâmaraQuentePreviewEdit"
                    ><i class="fas fa-camera" aria-hidden="true"></i
                  ></label>

                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    @change="previewFiles($event, 1)"
                    id="IDdaCâmaraQuentePreviewEdit"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section_image">
          <div>
            <div class="image-preview" v-if="imageData[2] != undefined">
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(2)"></div>
              </div>
              <img
                v-if="
                  imageData[2].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                :src="`${imageData[2]}.webp`"
                id="ladodireitoPreviewEdit"
                @click="clickPreview(imageData[2])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[2]}`"
                id="ladodireitoPreviewEdit"
                @click="clickPreview(imageData[2])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="ladodireito"
                  @change="previewFiles($event, 2)"
                  multiple
                  hidden
                />
                <label class="palavra" for="ladodireito">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>

            <!--  -->

            <div class="">
              <p class="title">Lado Direito</p>
              <div class="icons">
                <div class="btn-group" v-if="imageData[2] != undefined">
                  <label
                    class="botao-editar"
                    for="FotodoLadoDireitoPreviewEdit"
                  ></label>

                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    @change="previewFiles($event, 2)"
                    id="FotodoLadoDireitoPreviewEdit"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section_image">
          <div>
            <div class="image-preview" v-if="imageData[3] != undefined">
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(3)"></div>
              </div>
              <img
                v-if="
                  imageData[3].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                :src="`${imageData[3]}.webp`"
                id="fotoladoesquerdoPreviewEdit"
                @click="clickPreview(imageData[3])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[3]}`"
                id="fotoladoesquerdoPreviewEdit"
                @click="clickPreview(imageData[3])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="ladoesquerdo"
                  @change="previewFiles($event, 3)"
                  multiple
                  hidden
                />
                <label class="palavra" for="ladoesquerdo">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>

            <!--  -->

            <div>
              <p class="title">Lado Esquerdo</p>
              <div class="icons">
                <div class="btn-group" v-if="imageData[3] != undefined">
                  <label
                    class="botao-editar"
                    for="FotodoLadoEsquerdoPreviewEdit"
                  ></label>

                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    @change="previewFiles($event, 3)"
                    id="FotodoLadoEsquerdoPreviewEdit"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section_image">
          <div>
            <div class="image-preview" v-if="imageData[4] != undefined">
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(4)"></div>
              </div>
              <img
                v-if="
                  imageData[4].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                :src="`${imageData[4]}.webp`"
                id="placadoladomovelEdit"
                @click="clickPreview(imageData[4])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[4]}`"
                id="placadoladomovelEdit"
                @click="clickPreview(imageData[4])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="placadoladomovel"
                  @change="previewFiles($event, 4)"
                  multiple
                  hidden
                />
                <label class="palavra" for="placadoladomovel">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>

            <!--  -->

            <div>
              <p class="title">Placa do Lado Móvel</p>
              <div class="icons">
                <div class="btn-group" v-if="imageData[4] != undefined">
                  <label
                    class="botao-editar"
                    for="FotodaPlacadoLadoMovelPreviewEdit"
                  ></label>

                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    @change="previewFiles($event, 4)"
                    id="FotodaPlacadoLadoMovelPreviewEdit"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section_image">
          <div>
            <!--  -->
            <div class="image-preview" v-if="imageData[5] != undefined">
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(5)"></div>
              </div>
              <img
                v-if="
                  imageData[5].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                :src="`${imageData[5]}.webp`"
                id="placadoladofixoEdit"
                @click="clickPreview(imageData[5])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[5]}`"
                id="placadoladofixoEdit"
                @click="clickPreview(imageData[5])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="placadoladofixo"
                  @change="previewFiles($event, 5)"
                  multiple
                  hidden
                />
                <label class="palavra" for="placadoladofixo">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>

            <!--  -->

            <div>
              <p class="title">Placa do Lado Fixo</p>
              <div class="icons">
                <div class="btn-group" v-if="imageData[5] != undefined">
                  <label
                    class="botao-editar"
                    for="FotodaPlacadoLadoFixoPreviewEdit"
                  ></label>

                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    @change="previewFiles($event, 5)"
                    id="FotodaPlacadoLadoFixoPreviewEdit"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section_image">
          <div>
            <!--  -->
            <div class="image-preview" v-if="imageData[6] != undefined">
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(6)"></div>
              </div>
              <img
                v-if="
                  imageData[6].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                :src="`${imageData[6]}.webp`"
                id="ladosuperiorEdit"
                @click="clickPreview(imageData[6])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[6]}`"
                id="ladosuperiorEdit"
                @click="clickPreview(imageData[6])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="ladosuperior"
                  @change="previewFiles($event, 6)"
                  multiple
                  hidden
                />
                <label class="palavra" for="ladosuperior">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>

            <!--  -->

            <div>
              <p class="title">Lado Superior</p>
              <div class="icons">
                <div class="btn-group" v-if="imageData[6] != undefined">
                  <label
                    class="botao-editar"
                    for="FotodoLadoSuperiorPreviewEdit"
                  ></label>
                  <input
                    hidden
                    type="file"
                    accept="image/*"
                    @change="previewFiles($event, 6)"
                    id="FotodoLadoSuperiorPreviewEdit"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section_image">
          <div>
            <!--  -->
            <div class="image-preview" v-if="imageData[7] != undefined">
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(7)"></div>
              </div>
              <img
                v-if="
                  imageData[7].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                :src="`${imageData[7]}.webp`"
                id="plaquetadosistemaderefrigeracaoEdit"
                @click="clickPreview(imageData[7])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[7]}`"
                id="plaquetadosistemaderefrigeracaoEdit"
                @click="clickPreview(imageData[7])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="plaquetadosistemaderefrigeracao"
                  @change="previewFiles($event, 7)"
                  multiple
                  hidden
                />
                <label class="palavra" for="plaquetadosistemaderefrigeracao">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>

            <!--  -->

            <div>
              <p class="title">Plaqueta do sistema de refrigeração</p>
              <div class="icons">
                <div class="btn-group" v-if="imageData[7] != undefined">
                  <label
                    class="botao-editar"
                    for="FotodaPlaquetadosistemadeRefrigeraçãoPreviewEdit"
                  ></label>

                  <input
                    hidden
                    type="file"
                    accept="image/*"
                    @change="previewFiles($event, 7)"
                    id="FotodaPlaquetadosistemadeRefrigeraçãoPreviewEdit"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputI1 from "../../../../../Inputs-defaults/Inp-1.vue";
export default {
  components: { InputI1 },
  props: {
    configInputs: Number,
  },
  async created() {
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  data() {
    return {
      imageData: [],

      FormDataImages: {
        FotoPlaquetadeIdentificacaodomoldeFile: [],
        IDdaCâmaraQuenteFile: [],
        FotodoLadoDireitoFile: [],
        FotodoLadoEsquerdoFile: [],
        FotodaPlacadoLadoMovelFile: [],
        FotodaPlacadoLadoFixoFile: [],
        FotodoLadoSuperiorFile: [],
        FotodaPlaquetadosistemadeRefrigeraçãoFile: [],
      },
    };
  },

  watch: {
    FormDataImages: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.$store.commit("MutationImagesMoldeFechado", newValue);
      },
    },
  },
  methods: {
    clickPreview(base64) {
      this.$swal
        .fire({
          imageUrl: base64,
          imageAlt: "Imagem carregada",
          confirmButtonText: "Baixar",
          showCloseButton: true,
          background: "#fff",
          customClass: {
            popup: "preview-modal-popup",
            image: "preview-modal-image",
            confirmButton: "preview-modal-button",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            const link = document.createElement("a");
            link.href = base64;
            link.download = "imagem.jpg";
            link.click();
          }
        });
    },
    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;
      if (dataQuery.ImagesRRIM[0].IMG_MF_PLA_ID) {
        this.imageData[0] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_PLA_ID}`;
        this.FormDataImages.FotoPlaquetadeIdentificacaodomoldeFile =
          dataQuery.ImagesRRIM[0].IMG_MF_PLA_ID;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_CAM_QUENTE != null) {
        this.imageData[1] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_CAM_QUENTE}`;
        this.FormDataImages.IDdaCâmaraQuenteFile =
          dataQuery.ImagesRRIM[0].IMG_MF_CAM_QUENTE;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_L_DIREITO) {
        this.imageData[2] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_L_DIREITO}`;
        this.FormDataImages.FotodoLadoDireitoFile =
          dataQuery.ImagesRRIM[0].IMG_MF_L_DIREITO;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_L_ESQUERDO) {
        this.imageData[3] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_L_ESQUERDO}`;
        this.FormDataImages.FotodoLadoEsquerdoFile =
          dataQuery.ImagesRRIM[0].IMG_MF_L_ESQUERDO;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_MOVEL != null) {
        this.imageData[4] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_MOVEL}`;
        this.FormDataImages.FotodaPlacadoLadoMovelFile =
          dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_MOVEL;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_FIXO) {
        this.imageData[5] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_FIXO}`;
        this.FormDataImages.FotodaPlacadoLadoFixoFile =
          dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_FIXO;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_L_SUPERIOR) {
        this.imageData[6] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_L_SUPERIOR}`;
        this.FormDataImages.FotodoLadoSuperiorFile =
          dataQuery.ImagesRRIM[0].IMG_MF_L_SUPERIOR;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_PLA_SIS_REF != null) {
        this.imageData[7] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_PLA_SIS_REF}`;
        this.FormDataImages.FotodaPlaquetadosistemadeRefrigeraçãoFile =
          dataQuery.ImagesRRIM[0].IMG_MF_PLA_SIS_REF;
      }
    },

    previewFiles(event, position) {
      // Referência ao elemento de entrada DOM
      var input = event.target;
      // Certifique-se de que possui um arquivo antes de tentar lê-lo
      if (input.files && input.files[0]) {
        const file = input.files[0];

        // Verifica se o arquivo é do tipo imagem
        if (!file.type.startsWith("image/")) {
          this.$swal.fire({
            icon: "error",
            title: "Arquivo inválido",
            text: "Por favor, selecione apenas arquivos de imagem.",
            confirmButtonColor: "#e74c3c",
          });
          input.value = ""; // Limpa o campo
          return;
        }
        //Identificando em qual contexto a imagem se encaixa
        switch (position) {
          case 0:
            this.FormDataImages.FotoPlaquetadeIdentificacaodomoldeFile =
              input.files[0];
            break;
          case 1:
            this.FormDataImages.IDdaCâmaraQuenteFile = input.files[0];
            break;
          case 2:
            this.FormDataImages.FotodoLadoDireitoFile = input.files[0];
            break;
          case 3:
            this.FormDataImages.FotodoLadoEsquerdoFile = input.files[0];
            break;
          case 4:
            this.FormDataImages.FotodaPlacadoLadoMovelFile = input.files[0];
            break;
          case 5:
            this.FormDataImages.FotodaPlacadoLadoFixoFile = input.files[0];
            break;
          case 6:
            this.FormDataImages.FotodoLadoSuperiorFile = input.files[0];
            break;
          case 7:
            this.FormDataImages.FotodaPlaquetadosistemadeRefrigeraçãoFile =
              input.files[0];
            break;
        }
        // this.$emit("setFotosAbertEmb",this.FormDataImages)
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // crie um novo FileReader para ler esta imagem e converter para o formato base64
        reader.onload = (e) => {
          // Note: função de seta usada aqui, de modo que "this.imageData" se refira ao componente imageData do Vue
          // Leia a imagem como base64 e defina como imageData
          this.imageData[position] = e.target.result;
        };
        // Inicie o trabalho do leitor - leia o arquivo como url de dados (formato base64)
        reader.readAsDataURL(input.files[0]);

        //Acionar $Emit para enviar o objeto quando um File for adicionado
      }
    },

    resetFile(position) {
      this.imageData[position] = null;

      switch (position) {
        case 0:
          this.FormDataImages.FotoPlaquetadeIdentificacaodomoldeFile = [];
          break;
        case 1:
          this.FormDataImages.IDdaCâmaraQuenteFile = [];
          break;
        case 2:
          this.FormDataImages.FotodoLadoDireitoFile = [];
          break;
        case 3:
          this.FormDataImages.FotodoLadoEsquerdoFile = [];
          break;
        case 4:
          this.FormDataImages.FotodaPlacadoLadoMovelFile = [];
          break;
        case 5:
          this.FormDataImages.FotodaPlacadoLadoFixoFile = [];
          break;
        case 6:
          this.FormDataImages.FotodoLadoSuperiorFile = [];
          break;
        case 7:
          this.FormDataImages.FotodaPlaquetadosistemadeRefrigeraçãoFile = [];
          break;
      }
    },
  },
};
</script>

<style scoped>
.botao-editar {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: white;
  background-image: url(../../../../../../static/icons/photo_camera_dark.svg) !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70%;
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-family: "Poppins", sans-serif;
  width: 3rem;
  height: 3rem;
  border: 3px solid var(--font_color);
}

.botao-editar:hover {
  background-color: var(--font_color);
  border: none;
  background-image: url(../../../../../../static/icons/photo_camera_white.svg) !important;
}

.btn-group {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.swal2-image.original-size-image {
  max-width: 90vw;
  max-height: 80vh;
  width: auto;
  height: auto;
  border-radius: 1rem;
}

.container {
  position: relative;
  width: 12rem !important;
  height: 12rem !important;
  object-fit: cover;
  object-position: center;
  border-radius: 1rem;
  border: 2px solid #ccc;
  cursor: pointer;
}

.section {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  max-width: 52.2rem;
  justify-content: center;
  margin-top: 1rem;
}

.title {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  margin-top: 0.5rem;
  word-wrap: break-word;
  width: 90%;
}

.title-container {
  width: 90%;
}

.section_image {
  max-width: 12rem !important;
  display: inline-block;
}

.title {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  margin-top: 0.5rem;
}

.palavra {
  max-width: 12rem !important;
}

.palavra1 {
  background-color: var(--bgProcess);
  background-image: url(../../../../../../static/icons/+_black.svg);
  width: 12rem !important;
  height: 12rem !important;
  border-radius: 1rem;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 15%;
}

.palavra1:hover {
  background-color: rgb(156, 150, 150);
}

.image-preview {
  position: relative;
}

.removeimage {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 3;
  cursor: pointer;
}

#fotoEmbalagemPreview {
  position: relative;
  z-index: 2;
  border-radius: 1rem;
}

.closeimage {
  width: 24px;
  height: 24px;
  background: url(../../../../../../static/icons/closeimage.svg) no-repeat
    center;
  background-size: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  cursor: pointer;
}

.extra-input {
  background-color: rgba(255, 255, 255, 0);
  padding: 0 !important;
  height: 1rem !important;
  border: none !important;
  color: var(--font_color);
  font-weight: 600;
  font-family: "Poppins", "sans-serif";
}

.container {
  border-radius: 0.8rem !important;
}

.empty {
  background-image: url("../../../../../../static/icons/empty-image.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 40%;
  width: 12rem;
  height: 12rem;
  border: 2px solid #757575;
  border-radius: 1rem;
}
</style>
